<app-navbar></app-navbar>

<div class="admin-hostings-page p-6">
  <!-- Tarjetas de estadísticas -->
  <div class="stats-grid mb-8">
    <div class="stat-card" *ngFor="let stat of stats">
      <div class="stat-header">
        <span>{{ stat.label }}</span>
        <mat-icon>{{ stat.icon }}</mat-icon>
      </div>
      <div class="stat-value">{{ stat.value }}</div>
      <div class="stat-sub">{{ stat.sub }}</div>
    </div>
  </div>

  <!-- Header de la sección -->
  <div class="hostings-header flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
    <div>
      <h2 class="text-xl font-semibold text-gray-900">Mis Alojamientos</h2>
      <p class="text-sm text-gray-500">Gestiona y administra tus propiedades</p>
    </div>

    <div class="flex items-center gap-3 mt-3 sm:mt-0">
      <input type="text" placeholder="Buscar alojamientos..." class="search-input" />

      <button mat-flat-button color="primary" class="btn-new flex items-center justify-center"
        (click)="openCreateModal()">
        <mat-icon fontIcon="add"></mat-icon>
        <span class="hidden sm:inline">Nuevo Alojamiento</span>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="is_loading" class="loading-container">
    <div class="spinner"></div>
    <p>Cargando alojamientos...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="error_msg" class="error-message">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error_msg }}</span>
  </div>

  <!-- Empty State -->
  <div *ngIf="!is_loading && hostings.length === 0 && !error_msg" class="empty-state">
    <mat-icon>home_work</mat-icon>
    <h3>No hay alojamientos registrados</h3>
    <p>Comienza agregando tu primer alojamiento</p>
    <button mat-flat-button color="primary" class="btn-new" (click)="openCreateModal()">
      <span>Agregar Alojamiento</span>
    </button>
  </div>

  <!-- Grid de Alojamientos -->
  <div class="hostings-grid mb-6" *ngIf="!is_loading && hostings.length > 0">
    <div class="hosting-card" *ngFor="let hosting of paginatedHostings">
      <!-- Badge de estado -->
      <div class="status-badges">
        <span class="badge badge-active">Activo</span>
        <span class="badge badge-cabin">{{ hosting.type }}</span>
      </div>

      <!-- Menú de opciones -->
      <button mat-icon-button class="menu-button" [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="openEditModal(hosting)">
          <mat-icon>edit</mat-icon>
          <span>Editar</span>
        </button>
        <button mat-menu-item (click)="gestionarLandings(hosting)">
          <mat-icon>web</mat-icon>
          <span>Gestionar Landing Pages</span>
        </button>
        <button mat-menu-item (click)="deleteHosting(hosting.id)" class="text-red-600">
          <mat-icon>delete</mat-icon>
          <span>Eliminar</span>
        </button>
      </mat-menu>

      <!-- Imagen -->
      <div class="hosting-image">
        <img [src]="getHostingImage(hosting)" [alt]="hosting.name" />
      </div>

      <!-- Contenido -->
      <div class="hosting-content">
        <!-- Título y Rating -->
        <div class="flex items-start justify-between mb-2">
          <h3 class="hosting-title">{{ hosting.name }}</h3>
          <div class="rating">
            <mat-icon class="star-icon">star</mat-icon>
            <span>{{ getHostingRating(hosting) }}</span>
          </div>
        </div>

        <!-- Ubicación -->
        <div class="location mb-3">
          <mat-icon>location_on</mat-icon>
          <span>{{ hosting.location?.city || 'Sin ubicación' }}</span>
        </div>

        <!-- Amenidades -->
        <div class="amenities mb-3">
          <div class="amenity" *ngFor="let serviceIncluded of hosting.included_services">
            <mat-icon>{{ serviceIncluded.icon}}</mat-icon>
            <span>{{ serviceIncluded.name }}</span>
          </div>
        </div>

        <!-- Contacto -->
        <div class="contact-info mb-4">
          <div class="contact-item" *ngIf="hosting.phone">
            <mat-icon>phone</mat-icon>
            <span>{{ hosting.phone }}</span>
          </div>
          <div class="contact-item" *ngIf="hosting.email">
            <mat-icon>email</mat-icon>
            <span>{{ hosting.email }}</span>
          </div>
        </div>

        <!-- Footer con precio y botón -->
        <div class="hosting-footer">
          <div class="price">
            <span class="price-amount">{{ getPricing(hosting) }}</span>
            <span class="price-label">por noche</span>
          </div>
          <button mat-stroked-button color="primary" (click)="openEditModal(hosting)" class="btn-edit">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Paginador personalizado -->
  <div class="pagination-container" *ngIf="!is_loading && hostings.length > 0">
    <div class="pagination-info">
      <span class="text-sm text-gray-600">
        Mostrando {{ (current_page * page_size) + 1 }} -
        {{ Math.min((current_page + 1) * page_size, hostings.length) }}
        de {{ hostings.length }} alojamientos
      </span>
    </div>

    <div class="pagination-controls">
      <!-- Selector de cantidad por página -->
      <mat-form-field appearance="outline" class="page-size-selector">
        <mat-label>Por página</mat-label>
        <mat-select [value]="page_size" (selectionChange)="onPageSizeChange($event.value)">
          <mat-option *ngFor="let size of page_size_options" [value]="size">
            {{ size }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Navegación de páginas -->
      <div class="page-navigation">
        <button mat-icon-button [disabled]="current_page === 0" (click)="onPageChange(current_page - 1)"
          class="nav-button">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <div class="page-numbers">
          <button *ngFor="let page of [].constructor(totalPages); let i = index" mat-button
            [class.active]="i === current_page" (click)="onPageChange(i)" class="page-number">
            {{ i + 1 }}
          </button>
        </div>

        <button mat-icon-button [disabled]="current_page === totalPages - 1" (click)="onPageChange(current_page + 1)"
          class="nav-button">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
